// src/utils/mailboxAxios.js
import axios from "axios";
import { getAuth } from "firebase/auth";
import { MAILSERVER_BASE } from "../config/mailserver";

const mailboxAxios = axios.create({
  baseURL: MAILSERVER_BASE,
  withCredentials: false,
});

mailboxAxios.interceptors.request.use(async (config) => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (user) {
    const token = await user.getIdToken();
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default mailboxAxios;